<app-page-content header="Technology. Done right.">
  <ng-template #subtitle>
    <p class="text-4">We build custom web software for growing businesses.</p>
    <section class="cta">
      <a class="btn btn-primary" routerLink="/contact">Get started</a>
      <a routerLink="/services">View services</a>
    </section>
  </ng-template>

  <h2 class="text-2 section-header" style="text-align: center">What we do</h2>

  <section class="wwd">
    <app-offering-card
      header="Business websites"
      fragment="business-websites"
      src="home/business-websites-icon.svg"
    />

    <app-offering-card
      header="Integrations and automation"
      fragment="integrations-and-automation"
      src="home/integrations-and-automation-icon.svg"
    />

    <app-offering-card
      header="Custom applications"
      fragment="custom-applications"
      src="home/custom-applications-icon.svg"
    />
  </section>

  <h2 class="text-2 section-header" style="text-align: center">
    A few things we care about.
  </h2>

  <app-priority-card
    header="Built for business needs"
    subheader="Not experiments. Not hype. Practical solutions that work."
    src="home/business-needs.svg"
    alt="Built for business needs"
    [priority]="true"
  />

  <app-priority-card
    header="Clear communication"
    subheader="You’ll always understand what’s being built and why."
    src="home/clear-communication.svg"
    alt="Clear communication"
    layout="row-reverse"
  />

  <app-priority-card
    header="Designed to scale"
    subheader="We build for where your business is going — not just today."
    src="home/designed-to-scale.svg"
    alt="Designed to scale"
  />
</app-page-content>
